import { ViewerLinkApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useViewerLinkAdd = () => {
  const [ViewerLinkAdd] = useAPIAction(
    ViewerLinkApi,
    async (api: ViewerLinkApi, ViewerLinkAddDetails: any) => {
      const { id, days, password } = ViewerLinkAddDetails;

      let data = await api.statisticalViewerLinkCreate({
        id: id,
        reportingMelcoMachineStatisticsModelsCreateViewerLink: {
          days: days,
          password: password,
        },
      });

      return {
        data,
        successMessages: [{ message: "default" }],
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "reporting.machinestatus.view.viewerlink.actions.add",
    }
  );

  return useCallback(
    async (ViewerLinkAddDetails: any) => {
      return await ViewerLinkAdd(ViewerLinkAddDetails);
    },
    [ViewerLinkAdd]
  );
};
